import PrivacyPolicypdf from "../../assets/pdf/2023 02 17 ATAImpex Privacy Policy (draft)[52].pdf";

const PrivacyPolicy = () => {
  return (
    <>
      <object
        data={PrivacyPolicypdf}
        type="application/pdf"
        width="100%"
        height="100%"
      >
        <p>
          Terms and Conditions{" "}
          <a href={PrivacyPolicypdf}>click here to download</a>
        </p>
      </object>
    </>
  );
};

export default PrivacyPolicy;
